import React, {useEffect, useState} from "react";
import { Statistic, Row, Col, Card } from "antd";
import { fetchPlatformReportMerchantStatistics } from "../../../services/platformReport";

const StatisticsView = (props) => {
    const [statisticData, setStatisticData] = useState({});

    const postPlatformReportStatistics = () => {
        fetchPlatformReportMerchantStatistics(props.params).then(res => {
            setStatisticData(res)
        })
    }
    useEffect(() => {
        postPlatformReportStatistics()
       
    }, [props.params]);

    return (
        <Row gutter={16} >
            <Col span={8}>
                <Card>
                    <Statistic title="总金额" value={statisticData.totalMoney} precision={2} />
                </Card>
            </Col>
            <Col span={8}>
                <Card>
                    <Statistic title="平台商户分账金额" value={statisticData.platformAmount} precision={2} />
                </Card>
            </Col>
            <Col span={8}>
                <Card>
                    <Statistic title="子商户分账金额" value={statisticData.subAmount} precision={2} />
                </Card>
            </Col>
        </Row>
    );
};

export default StatisticsView;



// WEBPACK FOOTER //
// ./src/page/AccountingRecordReport/components/MerchantReportInfoStatisticsView.jsx